module.exports = ".titleMenu{\n    color: #066;\n    margin-top: 30px;\n    margin-bottom: 10px;\n    font-size: 18px;\n    font-weight: bold;\n    margin-left: auto;\n    width: auto;\n    margin-right: auto;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/broker/broker-audit-declaration/questionnaire-broker-audit-declaration/bad-questionnaire-save-data/bad-questionnaire-save-data.component.css
// module id = ./src/app/broker/broker-audit-declaration/questionnaire-broker-audit-declaration/bad-questionnaire-save-data/bad-questionnaire-save-data.component.css
// module chunks = main